module.exports = __webpack_public_path__ + "img/pds_guide_screen2.e47b1c44.svg";